import React from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import CopyRight from "../../Assets/CopyRight";
import Button from "../../components/Button";
import Gap from "../../components/Gap";
import Input from "../../components/Input";
import InputPhone from "../../components/InputPhone";
import { onSaveCustomer } from "../../config/config";
import { router } from "../../Constants";
import { encrypt } from "../../utils/enkripsi";
import { showLog } from "../../utils/log";

function DataDiri() {
  const { addToast } = useToasts();
  let navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [input, setInput] = React.useState({
    name: "",
    mobile: "",
    birth_date: "",
    email: "-",
  });

  function validateNotEmpty(field, fieldName) {
    showLog("DataDiri Masuk validateNotEmpty");
    if (!field || field.trim() === "") {
      return addToast(`${fieldName} tidak boleh kosong`, {
        appearance: "error",
        autoDismiss: true,
      });
    }
  }

  async function onSave() {
    showLog("DataDiri Masuk onSave");
    const dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    validateNotEmpty(input.name, "Nama");
    validateNotEmpty(input.mobile, "Nomor Handphone");
    validateNotEmpty(input.birth_date, "Tanggal Lahir");
    if (input.mobile.length > 17) {
      input.mobile = input.mobile.substring(0, 17);
    }
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // if (!emailRegex.test(input.email)) {
    //   return addToast(`Format email tidak valid`, {
    //     appearance: "error",
    //     autoDismiss: true,
    //   });
    // }
    const nameWithoutSpaces = input.name.replace(/\s+/g, "").toLowerCase();
    const mobilePart = input.mobile;
    let id = `${nameWithoutSpaces}-${mobilePart}`;
    if (id.length > 30) {
      id = id.substring(0, 30);
    }
    input.id = id;
    input.old_id = id;
    input.id_card_type = "ktp";
    input.id_card_no = "";
    input.nationality = "62";
    input.si_id = dataBranch.detailData;
    localStorage.setItem("detailDataCustomer", JSON.stringify(encrypt(input)));
    localStorage.setItem("dataDiriId", JSON.stringify(encrypt(id)));
    const result = await onSaveCustomer();
    if (result.status === "OK") {
      localStorage.setItem("typePayment", "Cash");
      // navigate(router + "/bill-cash");
      navigate(router + "/metode-pembayaran/" + id);
      localStorage.setItem("saveCustomer", JSON.stringify(encrypt("true")));
      // addToast(
      //   `Berhasil menyimpan customer dengan id ${input.id} ke database`,
      //   {
      //     appearance: "success",
      //     autoDismiss: true,
      //   }
      // );
    } else {
      localStorage.setItem("saveCustomer", JSON.stringify(encrypt("false")));
      // addToast(`Gagal menyimpan customer id ${input.id} ke database`, {
      //   appearance: "error",
      //   autoDismiss: true,
      // });
    }
  }

  return (
    <div>
      <div>
        <div
          style={{ marginTop: 10, marginLeft: 5, padding: 10 }}
          onClick={() => {
            navigate(`${router}/lacak-pesanan`);
          }}
        >
          <BiArrowBack size={20} />
        </div>
      </div>
      <div style={{ margin: "10% 20% 10px 20%" }}>
        <div
          style={{
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            padding: "30px 0px",
          }}
        >
          <div
            style={{ fontSize: 25, textAlign: "center" }}
            className="fonts700"
          >
            Silahkan Masukkan Data Diri Anda Untuk Melanjutkan ke Pembayaran
          </div>
        </div>
        <Input
          type="input"
          value={input.name}
          placeholder="Nama"
          label="Nama"
          onChange={(val) => {
            setInput((prevState) => ({
              ...prevState,
              name: val.target.value,
            }));
            localStorage.setItem("dataDiriName", val.target.value);
          }}
        />
        <Gap height={10} />
        <InputPhone
          type="input"
          value={input.mobile}
          label="Nomor Handphone"
          placeholder="8123456789"
          onChange={(val) => {
            setInput((prevState) => ({
              ...prevState,
              mobile: val,
            }));
            // localStorage.setItem("dataDiri-mobile", val.target.value);
          }}
        />
        <Gap height={10} />
        {/* <Input
          type="input"
          value={input.email}
          placeholder="Email"
          label="Email"
          onChange={(val) => {
            setInput((prevState) => ({
              ...prevState,
              email: val.target.value,
            }));
            localStorage.setItem("dataDiriEmail", val.target.value);
          }}
        /> */}
        <div>
          <div className="fonts500" style={{ paddingBottom: 5, fontSize: 15 }}>
            Tanggal Lahir
            <span
              style={{
                fontSize: 13,
                color: "#666",
                marginLeft: 8,
                fontStyle: "italic",
              }}
            >
              (Tanggal lahir Anda akan kami gunakan untuk keperluan promo dan
              penawaran spesial)
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "1px solid #E2E4E8",
            }}
          >
            <input
              type="date"
              value={input.birth_date}
              style={{
                padding: "0px 12px",
                height: 35,
                borderRadius: 5,
                border: "none",
                display: "inline-block",
                width: "-webkit-fill-available",
                fontSize: 14,
                width: "100%",
              }}
              onChange={(val) => {
                const tanggal = val.target.value;
                setInput((prevState) => ({
                  ...prevState,
                  birth_date: tanggal,
                }));
              }}
            />
          </div>
        </div>
        <Gap height={20} />
        <Button
          onClick={onSave}
          loading={loading}
          color="#fff"
          backgroundColor={"#5451D6"}
        >
          Submit
        </Button>
      </div>
      <div style={{ marginTop: "10%", textAlign: "center" }}>
        <CopyRight />
      </div>
      <div id="sign-in-button"></div>
    </div>
  );
}

export default DataDiri;
